import styled, { css } from 'styled-components';
import { spaceY, flex, media } from 'components/styles';
import dashedBorder from 'assets/images/dashed-border.svg';

export const Wrapper = styled.div`
	width: 100%;
	display: flex;
	flex-direction: column;
	${media.min.medium(css`
		max-width: 73.5rem;
	`)}
`;

const blueShadow = css`
	outline: none;
	border: 1px solid ${({ theme }) => theme.blueLight};
	box-shadow:
		inset 0 2px 2px ${({ theme }) => theme.drag_and_drop.translucent},
		0 0 8px ${({ theme }) => theme.drag_and_drop.blueShadow};
`;

const redShadow = css`
	outline: none;
	border: 1px solid ${({ theme }) => theme.palette.error};
	box-shadow:
		inset 0 2px 2px ${({ theme }) => theme.drag_and_drop.translucent},
		0 0 8px ${({ theme }) => theme.drag_and_drop.redShadow};
`;

export const Zone = styled.main`
	width: 100%;
	padding: 3rem 1rem;
	${flex()};
	flex-direction: column;
	${spaceY(9)};
	background: ${({ theme }) => theme.drag_and_drop.zone.background};
	background-image: url(${dashedBorder});
	border-radius: 4px;
	cursor: pointer;
	${({ isFocused, isFileDialogActive, isDragAccept }) =>
		(isFocused || isFileDialogActive || isDragAccept) &&
		css`
			${blueShadow}
		`};
	${({ isDragReject }) =>
		isDragReject &&
		css`
			${redShadow}
		`};
	${({ someError }) =>
		someError &&
		css`
			&:focus {
				outline: none;
				background-image: none;
				border: 1px solid ${({ theme }) => theme.palette.error};
			}
		`};
`;

export const FileList = styled.div`
	width: 100%;
	height: 100%;
	margin: 3rem 0;
	float: left;
`;

export const Title = styled.p`
	font-size: 1.4rem;
	font-weight: ${({ theme }) => theme.font.normal};
	color: ${({ theme }) => theme.silver};
	span {
		color: ${({ theme }) => theme.blueAzure};
		&:hover {
			text-decoration: underline;
		}
	}
`;

export const SubTitle = styled.p`
	font-weight: ${({ theme }) => theme.font.normal};
	font-size: 1rem;
	color: ${({ theme }) => theme.silver};
`;
